import React, {useMemo} from 'react';
import {useTranslation} from 'next-i18next';
import CustomLinkWithArrow from '@/_application/core/components/commons/custom-link-with-arrow';
import {Routes} from '@/config/routes';
import {mergeHighlightAndHotNewProducts} from '@/_application/modules/products/model/highlight-product';
import HighlightHotNewProductCard from '@/_application/modules/products/components/highlight-hot-new-product-card';
import {HighlightProductItem} from '@/__generated__/__types__';
import {Product} from '@/_application/modules/products/model/product';

export interface HighlightProductsProps {
    highlightProducts?: HighlightProductItem[];
    hotNewProducts?: Product[];
}

function HighlightProducts({highlightProducts = [], hotNewProducts = []}: HighlightProductsProps) {
    const {t} = useTranslation('common');

    const combinedProducts = useMemo(() => {
        if (highlightProducts.length > 0 && hotNewProducts.length > 0) {
            return mergeHighlightAndHotNewProducts(highlightProducts, hotNewProducts).filter(Boolean);
        }

        if (highlightProducts.length > 0) {
            return highlightProducts.filter(Boolean);
        }

        if (hotNewProducts.length > 0) {
            return hotNewProducts.filter(Boolean);
        }

        return [];
    }, [highlightProducts, hotNewProducts]);

    if (!combinedProducts.length) return null;

    const highlightProductsViewMoreLink = Routes.highlightProducts;

    return (
        <>
            <div className="mt-5 grid grid-cols-3 gap-5 lg:grid-cols-5">
                {combinedProducts.map((product, index) => (
                    <HighlightHotNewProductCard
                        amountOfHighlightProduct={highlightProducts?.length}
                        productItem={product}
                        index={index}
                        key={`product_${product?.id ?? index}_${index}`}
                    />
                ))}
            </div>
            <div className="mt-5 flex w-full items-center justify-center">
                <CustomLinkWithArrow text={t('text-view-all', 'Xem tất cả')} href={highlightProductsViewMoreLink} />
            </div>
        </>
    );
}

export default HighlightProducts;
